<template>
  <Suspense>
    <template #default>
      <Transition
        name="fade"
        mode="out-in"
        appear
      >
        <slot />
      </Transition>
    </template>
    <template #fallback>
      <Transition
        name="fade"
        mode="out-in"
        appear
      >
        <div class="space-y-4 p-4">
          <!-- Header Skeleton -->
          <SkeletonLoader height="40px" width="30%" />
          
          <!-- Content Skeletons -->
          <div class="space-y-4 mt-6">
            <SkeletonLoader v-for="i in 3" :key="i" height="100px" />
          </div>
          
          <!-- List Skeletons -->
          <div class="space-y-2 mt-6">
            <SkeletonLoader v-for="i in 5" :key="i" height="20px" />
          </div>
        </div>
      </Transition>
    </template>
  </Suspense>
</template>

<script setup>
import SkeletonLoader from './SkeletonLoader.vue';
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
